import { del, extractErrorMessage, get, patch, post } from "src/helpers/api_helper"
import { IConfig, ISetting, ISettingType, IUser, ResponsePagination, ResponseRequest } from "./types"
// import { GET_USERS } from "src/helpers/url_helper"
interface ISettingTypeId {
    setting_type_id: string;
}

export const getSettings = async (config: IConfig & ISettingTypeId): Promise<ResponseRequest<ResponsePagination<ISetting>>> => {
    try {
        const response = await get<ResponsePagination<ISetting>>('/settings', { params: config })
        if (response.code === 200) {
            return { result: "ok", data: response.data! }
        } else { 
            return { result: "error", message: response.message } 
        }
    } catch (error) {
        const message = extractErrorMessage(error)
        return { result: "error", message }
    }
}

export const updateSetting = async ( id: string, data: Partial<ISetting> ): Promise<ResponseRequest<unknown>> => {
    try {
        const response = await patch<unknown>(`/settings/${id}`, data)
        if (response.code === 200) {
            return { result: "ok", data: undefined }
        } else { 
            return { result: "error", message: response.message } 
        }
    } catch (error) {
        const message = extractErrorMessage(error)
        return { result: "error", message }
    }
}

export const getSettingTypes = async (): Promise<ResponseRequest<ISettingType[]>> => {
    try {
        const response = await get<ISettingType[]>('/settingTypes', { params: { per_page: 100} })
        if (response.code === 200) {
            return { result: "ok", data: response.data! }
        } else { 
            return { result: "error", message: response.message } 
        }
    } catch (error) {
        const message = extractErrorMessage(error)
        return { result: "error", message }
    }
}

export const updateSettingType = async ( id: string, data: Partial<ISettingType> ): Promise<ResponseRequest<unknown>> => {
    try {
        const response = await patch<unknown>(`/settingTypes/${id}`, data)
        if (response.code === 200) {
            return { result: "ok", data: undefined }
        } else { 
            return { result: "error", message: response.message } 
        }
    } catch (error) {
        const message = extractErrorMessage(error)
        return { result: "error", message }
    }
}

export const createSetting = async ( data: Partial<ISetting> ): Promise<ResponseRequest<unknown>> => {
    try {
        const response = await post<unknown>('/settings', data)
        if (response.code === 200) {
            return { result: "ok", data: undefined }
        } else { 
            return { result: "error", message: response.message } 
        }
    } catch (error) {
        const message = extractErrorMessage(error)
        return { result: "error", message }
    }
}